const brand = "brand";
const hashedRefs = /(\/[A-Za-z0-9]+)(-[A-Za-z0-9-]+)(\.js)/g;
const brandedEndpoints = 
// eslint-disable-next-line no-useless-escape
/(https?:\/\/talentassistant\.)([^\.]+)(\.com)/g;
function normalize(text) {
    return text
        .replace(hashedRefs, "$1$3")
        .replace(brandedEndpoints, `$1${brand}$3`);
}
export default function normalizeStackFrames(error) {
    if (error instanceof Error) {
        const result = new Error(normalize(error.message), { cause: error });
        if (error.stack) {
            result.stack = normalize(error.stack);
        }
        return result;
    }
    if (typeof error === "string") {
        return new Error(normalize(error));
    }
    return new Error("Unknown error");
}
